<template>
  <span v-if="normalizedTags.length" class="tag-icons">
    <span
      v-for="tag in normalizedTags"
      :key="tag.key"
      class="tag-icon"
      :title="tag.label"
    >
      <svg v-if="tag.kind === 'gluten-free'" viewBox="0 0 16 16" aria-hidden="true">
        <g transform="translate(0 0) scale(0.6667)">
          <path d="M15.247,13.836a3.115,3.115,0,0,0,.79-2.78,1.053,1.053,0,0,0-.8-.81,3.1,3.1,0,0,0,.8-2.79,1.061,1.061,0,0,0-.82-.82,3.211,3.211,0,0,0-2.04.25A3.09,3.09,0,0,0,14,4.816a3.1,3.1,0,0,0-1.41-2.57,1.043,1.043,0,0,0-1.16-.01A3.124,3.124,0,0,0,10,4.816a3.052,3.052,0,0,0,.83,2.07,3.154,3.154,0,0,0-2.04-.25,1.048,1.048,0,0,0-.82.82,3.1,3.1,0,0,0,.79,2.79,1.041,1.041,0,0,0-.79.81,3.11,3.11,0,0,0,.78,2.78,1.071,1.071,0,0,0-.78.82,3.031,3.031,0,0,0,3,3.7,2.436,2.436,0,0,0,.53-.05v3.15a.5.5,0,0,0,1,0v-3.15a2.469,2.469,0,0,0,.54.05,3.054,3.054,0,0,0,2.17-.88,3.124,3.124,0,0,0,.83-2.82A1.083,1.083,0,0,0,15.247,13.836Zm-3.83,3.48a2.12,2.12,0,0,1-1.92-.55,2.041,2.041,0,0,1-.51-1.96,2.558,2.558,0,0,1,.47-.04,1.984,1.984,0,0,1,1.45.59A2.011,2.011,0,0,1,11.417,17.316Zm0-3.6a2.112,2.112,0,0,1-1.92-.55,2.022,2.022,0,0,1-.51-1.95,1.93,1.93,0,0,1,.47-.05,1.984,1.984,0,0,1,1.45.59A2.011,2.011,0,0,1,11.417,13.716Zm0-3.6a2.112,2.112,0,0,1-1.92-.55,2.022,2.022,0,0,1-.51-1.95,2.592,2.592,0,0,1,.47-.05,1.984,1.984,0,0,1,1.45.59A2.011,2.011,0,0,1,11.417,10.116Zm.56-3.55A2.1,2.1,0,0,1,11,4.816a2.005,2.005,0,0,1,1.04-1.74A2.1,2.1,0,0,1,13,4.816,2.054,2.054,0,0,1,11.977,6.566Zm2.53,10.2a2.072,2.072,0,0,1-1.96.51,2.384,2.384,0,0,1-.05-.45v-.02a2.065,2.065,0,0,1,.59-1.46,1.99,1.99,0,0,1,1.4-.57,2.279,2.279,0,0,1,.57.07A2.14,2.14,0,0,1,14.507,16.766Zm0-3.6a2.047,2.047,0,0,1-1.96.51,2.384,2.384,0,0,1-.05-.45v-.02a2.024,2.024,0,0,1,.59-1.45,1.957,1.957,0,0,1,1.4-.58,2.863,2.863,0,0,1,.57.07A2.14,2.14,0,0,1,14.507,13.166Zm0-3.6a2.024,2.024,0,0,1-1.96.51,2.384,2.384,0,0,1-.05-.45v-.02a2.024,2.024,0,0,1,.59-1.45,1.955,1.955,0,0,1,1.41-.57,2.259,2.259,0,0,1,.56.07A2.12,2.12,0,0,1,14.507,9.566Z" />
        </g>
      </svg>

      <svg v-else-if="tag.kind === 'dairy-free'" viewBox="0 0 16 16" aria-hidden="true">
        <g transform="translate(2 0.25) scale(0.25)">
          <path d="M7 6L7 13C7 13 0 23.9 0 25L0 60C0 61.1 0.9 62 2 62L20 62C21.1 62 22 61.1 22 60L22 25C22 23.9 15 13 15 13L15 6" />
          <path d="M17 4C17 5.1 16.1 6 15 6L7 6C5.9 6 5 5.1 5 4L5 2C5 0.9 5.9 0 7 0L15 0C16.1 0 17 0.9 17 2L17 4Z" />
        </g>
      </svg>

      <svg v-else-if="tag.kind === 'adjustment'" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M3 11.5V13h1.5L11 6.5L9.5 5L3 11.5ZM10.2 4.3L11.7 5.8L13 4.5L11.5 3L10.2 4.3Z" />
      </svg>
    </span>
  </span>
  <span v-else>-</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  tags: { type: Array, default: () => [] },
})

const TAG_META = [
  {
    key: 'bezglyutenovaya',
    label: 'Безглютеновая',
    kind: 'gluten-free',
    aliases: ['безглютеновая', 'без глютена', 'gluten free', 'gluten-free'],
  },
  {
    key: 'bezmolochnaya',
    label: 'Безмолочная',
    kind: 'dairy-free',
    aliases: ['безмолочная', 'без молока', 'dairy free', 'dairy-free'],
  },
  {
    key: 'korrektirovka',
    label: 'Корректировка',
    kind: 'adjustment',
    aliases: ['корректировка'],
  },
]

function normalizeTag(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
}

const normalizedTags = computed(() =>
  (props.tags || [])
    .map(tag => {
      const normalized = normalizeTag(tag?.name || tag)
      return TAG_META.find(item => item.aliases.includes(normalized)) || null
    })
    .filter(Boolean)
)
</script>

<style scoped>
.tag-icons {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.tag-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #2563eb;
}

.tag-icon svg {
  width: 15px;
  height: 15px;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}
</style>
